"use client";

import "./ChromaLab.css";
import "../../ShowCase.css"
import ProjectTitle from "@/components/ProjectsShowCase/ProjectTitle/ProjectTitle";
import YouTubeEmbed from "@/components/layout/YouTubeEmbeded/YouTubeEmbeded";
import ChromaBody from "../ChromaBody/ChromaBody";
import DecoratedText from "@/components/DecoratedText/DecoratedText";
import RoundCover from "@/components/layout/RoundCover/RoundCover";
import Carousel from "@/components/layout/CircularGallery/CircularGallery";

const imageNames = [
    "/Img/ChromaLab/Tower.png",
    "/Img/ChromaLab/Button.png",
    "/Img/ChromaLab/Traps.png",
    "/Img/ChromaLab/LastLvl.png",
    "/Img/ChromaLab/Levers.png",
    "/Img/ChromaLab/Barrel.png",
];

export default function ChromaLab() {
    return (
        <div>
            <ProjectTitle
                title={['“Chroma Lab Experiment“']}
                subtitle="Video Game Development in Unreal Engine"
                backgroundImage="/Img/chromaLabBG.png"
                accentColor="var(--primary-color)"
                paragraph={(
                    <>
                        <p>
                            The game about two cute characters, who are <strong>trying to escape a
                                laboratory</strong> where they are <strong>being held as lab rats.</strong> The <strong>"Chroma
                                    Laboratory"</strong> is known for producing <strong>toxic paint which gives
                                        the special abilities</strong> depending on the color.
                        </p>
                        <p>
                            <strong>In the story,</strong> the paint had to be tested before real life use,
                            therefore the special test subjects were invented. <strong>You are
                                playing as the test subject</strong> and have to proceed through all the
                            test chambers to escape.
                        </p>
                    </>
                )}
                components={[
                    "**3D object** modeling using Blender",
                    "**Texturing** using Substance Painter",
                    "Audio work in **Adobe Audition**",
                    "**Light and scenes**, as well as **gameplay using Unreal Engine 5**"
                ]}
                images={[
                    "/Img/CompLogo/Unreal.png",
                    "/Img/CompLogo/Blender.png",
                    "/Img/CompLogo/Audition.png",
                    "/Img/CompLogo/Substance painter.png",
                    "/Img/CompLogo/AfterEffect.png",
                ]} />

            <div className="type1-snd">
                <div className="project-text">
                    <h1>
                        <DecoratedText
                            text="project details"
                            decoratedIndex={8}
                            imageSrc={"/Img/Pigeons/gaming_pigeon.png"}
                        />
                    </h1>
                    <br />
                    <br />
                    <br />
                    <div className="project-text-flex type1">
                        <p className="sm-txt">
                            The game made in <strong>Unreal Engine </strong>
                            from scratch. Using Blender as a 3d modeling tool
                            and for rigging and animations, and Substance Painter
                            for texturing, I made an environment.
                        </p>
                        <p className="sm-txt">
                            It is a <strong>multiplayer, collaborative game
                                for 2 people</strong>, where you can solve puzzles
                            and escape a laboratory.
                        </p>
                    </div>
                </div>
                <Carousel images={ imageNames } />
            </div>
            <RoundCover bg_color="var(--primary-color)" color="white" />
            <ChromaBody />
            <YouTubeEmbed
                srcs={["https://www.youtube.com/embed/_w22oAPhTj4?si=l03lbVMrLALCvoBj"]}
                color="var(--primary-color)"
                text_color="white" />
        </div>
    );
}